/* global angular */

angular.module('specsguardApp')

  .filter('Number', function () {
    return function (value) {
      if (value === undefined || value === null) {
        value = '';
      } else {
        value = value.toString().replace('.', ',');
      }
      return value;
    };
  })

  .filter('String', function () {
    return function (value) {
      if (value === undefined || value === null) {
        value = '';
      } else {
        value = value.toString();
      }
      return value;
    };
  })

  .filter('reverse', function () {
    return function (items) {
      return items.slice().reverse();
    };
  })

  .filter('removeSpaces', function() {
    return function(string) {
      if (!angular.isString(string)) {
        return string;
      }

      return string.replace(/[\s]/g, '');
    };
  })

  .filter('characters', function () {
    return function (input, chars, breakOnWord) {
      if (isNaN(chars)) {
        return input;
      }
      if (chars <= 0) {
        return '';
      }
      if (input && input.length > chars) {
        input = input.substring(0, chars);

        if (!breakOnWord) {
          var lastspace = input.lastIndexOf(' ');
          // get last space
          if (lastspace !== -1) {
            input = input.substr(0, lastspace);
          }
        } else {
          while (input.charAt(input.length - 1) === ' ') {
            input = input.substr(0, input.length - 1);
          }
        }
        return input + '…';
      }
      return input;
    };
  })

  .filter('unique', function () {
    return function (collection, keyname) {
      const output = [],
        keys = [];
      angular.forEach(collection, function (item) {
        const key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    };
  });
